import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqContaSaida from "../../../../services/reqMultiTenant/reqContaSaida";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterAccountOut = () => {
	//#region Toda a customização para a criação de um novo formulario de cadastro
	const identForm = "account-out";
	const options = {
		id: "id_conta_saida", //usado para saber qual field usar para atualizar
		ident: `register${identForm}`, //usado para definir os event listners
		identFilter: `filter${identForm}`, //usado para definir os event listners
		title: "Conta Saída",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "descricao", label: "Descrição", align: "left" },
			{ key: "nome_fornecedor", label: "Fornecedor", align: "left" },
			{ key: "valor", label: "Valor", align: "left", format: "currency" },
			{ key: "parc", label: "Parcela", align: "center" },
			{ key: "data", label: "Dt. Parcela", align: "left", format: "date" },
			{ key: "ativo", label: "Status", align: "center", format: "badgePgto", clickable: true },
			{ key: "actions", label: "", align: "right" },
		],
		identReport: `report${identForm}`, //usado para definir os event listners
		reportColumns: [
			{ key: "descricao", label: "Descrição", align: "left", visible: true },
			{ key: "nome_fornecedor", label: "Fornecedor", align: "left", visible: true },
			{ key: "valor", label: "Valor", align: "left", format: "currency", visible: true },
			{ key: "parc", label: "Parcela", align: "center", visible: true },
			{ key: "data", label: "Dt. Parcela", align: "left", format: "date", visible: true },
			{ key: "ativo", label: "Status", align: "center", format: "badgePgto", visible: true },
		],
		parametersDate: [
			{ id: 1, label: "Data Cadastro", value: "dtSaida" },
			{ id: 2, label: "Dt. Vencimento", value: "dtVencimento" },
		],
		showTime: true, //mostra a hora no filtro de data
		hasActive: true,
		activeLabel: { true: "Pendente", false: "Pago" },

		hasSaleType: false,
		parametersFilter: [
			{ id: 1, label: "Fornecedor", value: "fornecedor" },
			{ id: 2, label: "Forma Pagamento", value: "formaPgto" },
			{ id: 3, label: "Descrição", value: "descricao" },
		],
	};
	//#endregion

	//#region Funções de acesso a dados do componente
	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };
		const response = await reqContaSaida.listPaginate(newFilterData);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqContaSaida.listID(currentId);
		return response;
	};

	const fetchIdGroup = async (currentId) => {
		const response = await reqContaSaida.listIDGroup(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqContaSaida.insert(data);

		return response;
	};
	//#endregion

	return (
		// RegisterProvider é o componente que gerencia o estado do formulário
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert} fetchIdGroup={fetchIdGroup}>
			{/* FormComponent é o componente que contém o formulário de cadastro e do filtro de pesquisa*/}
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterReportDateItens} />
		</RegisterProvider>
	);
};

export default MainRegisterAccountOut;
